export const objectToQueryString = (queryObject: {[k: string]: string | number} = {}) => {
    const queryParams = new URLSearchParams();

    for (const key of Object.keys(queryObject)) {
        queryParams.append(key, `${queryObject[key]}`);
    }

    return queryParams.toString();
};
